import { render, staticRenderFns } from "./LookFiltro.vue?vue&type=template&id=b1fdbf8a&"
import script from "./LookFiltro.vue?vue&type=script&lang=js&"
export * from "./LookFiltro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports